import React from 'react'
import { SpecificationsList } from '../SpecificationsList'
import { SwapList } from '../SwapList'
import { Compatibilities } from '../../Compatibilities'
import { Condition } from '../Condition'

export const Container = () =>
  <div className='oglasi-info-left'>
    <div className='oglasi-osnovne-informacije'>
      <ul>
        <Condition />
        <SpecificationsList />
        <SwapList />
      </ul>
      <br />
      <Compatibilities />
    </div>
  </div>

Container.displayName = 'LeftColumn'
